import api from './api';
import auth from './auth';
import cfg from '../../app/cfg';
import ui from './ui';

import {tableIconsRecalculate} from './tableIcons';
import tx, {txLoadLang, txSetLang} from './tx';

import {reactive, readonly} from "vue";

import vias from './vias';
import booking from '../../features/booking/app/bookingApi';
import bookingStatus from '../../features/booking/app/bookingStatus';
import paymentMethod from '../../features/billing/app/paymentMethod';
import invoiceType from '../../features/billing/app/invoiceType';
import countDaysMode from './countDaysMode';
import parkingApp from "@/features/parking/app/parkingApp";
import rating from "@/core/app/rating";
import extraSaleStatus from "@/features/extra-sale/app/extraSaleStatus";
import bookingExtraConcept from "@/features/booking/app/bookingExtraConcept";
import { ShuttleCalls} from "@/features/shuttle-calls/components/shuttle-calls";
import contractTerminationReason from "@/features/contract/app/contractTerminationReason";


const state = reactive({
    lang: null,
    username: null,
    colorTheme: localStorage.getItem('colorTheme') ?? cfg.colorTheme,
    fontTheme: localStorage.getItem('fontTheme') ?? cfg.fontTheme,
    parking: {id: 0, name: 'Parking'},
    sessionReady: false,
    shuttleCallNum:0,
    shuttleCalls:[],
    shuttleTimerSeconds:  Number(localStorage.getItem('shuttleTimerSeconds') ?? 0) || 0,
});



async function setLang(langCode) {
    txSetLang(langCode);

    let langCodeSanitized = tx.getLangCode();

    api.setLang(langCodeSanitized);

    await txLoadLang();
    state.lang = langCodeSanitized;

    tableIconsRecalculate();
    vias.translateNames();
    bookingStatus.translateNames();
    bookingStatus.translateNamesForList();
    booking.onChangeLang();
    paymentMethod.translateNames();
    invoiceType.translateNames();
    countDaysMode.translateNames();
    rating.translateNames();
    extraSaleStatus.translateNames();
    bookingExtraConcept.translateNames();
    contractTerminationReason.translateNames();
}

async function loadSessionLang() {
    await setLang(tx.getLangCode());
}

async function initPrivateSession() {
    await auth.loadStoredSession();
    if (!auth.isLoggedIn()) return;
    ui.applyThemes(state.colorTheme, state.fontTheme);
    await loadSessionLang();
    state.sessionReady = true;
}


async function requireSession() {
    if (!state.sessionReady)
        await initPrivateSession();
}


function setColorTheme(colorTheme) {
    state.colorTheme = colorTheme;
    localStorage.setItem('colorTheme', colorTheme);
    ui.applyThemes(state.colorTheme, state.fontTheme);
}

function setFontTheme(colorTheme) {
    state.fontTheme = colorTheme;
    localStorage.setItem('fontTheme', colorTheme);
    ui.applyThemes(state.colorTheme, state.fontTheme);
}


function setUsername(name) {
    state.username = name;
}

async function setParking(id) {
    if (state.parking.id == id)
        return true;


    let result = await api.getId('parking', id);
    if (result.ok) {
        state.parking.id = result.data.id;
        state.parking.name = result.data.name;
        parkingApp.setIdParking(state.parking.id);
        return true;
    }

    return false;
}


function sanitizeAlphanumericUpper(text) {
    return text.toUpperCase().replace(/[^A-Z0-9]/g, '');
}

function sanitizeCarPlate(plate) {
    //return sanitizeAlphanumericUpper(plate);
    return plate;
}

function sanitizeDigits(number) {
    return number.replace(/[^0-9]/g, '');
}

/**
 * Returns int value for an id, null for invalid
 * @param {string|number|null}id
 * @param {number:null} zeroValue return value where id==0
 * @returns {null|number} null on invalid
 */
function sanitizeId(id, zeroValue = null) {
    let parsed = parseInt(id);
    if (isNaN(parsed) || parsed < 0) return null;
    return (0 === parsed) ? zeroValue : parsed;
}

function setShuttleCalls (calls) {
    console.log(calls);
    state.shuttleCalls = calls;
    state.shuttleCallNum =  calls.length;
}
function removeShuttleCall(index) {
    state.shuttleCalls.splice(index, 1);
}


let shuttleInterval = null;
async function setShuttleTimer (seconds) {
    state.shuttleTimerSeconds = seconds;
    localStorage.setItem('shuttleTimerSeconds', seconds);

    clearInterval(shuttleInterval);
    if (seconds) {
        shuttleInterval =setInterval(() => { ShuttleCalls.refresh()}, seconds*1000);
        setTimeout ( ()=>{ShuttleCalls.refresh();}, 500);

    }
}
//Initialize shuttles form session config;
setShuttleTimer(state.shuttleTimerSeconds);




const cloneDTO = (dto) =>JSON.parse(JSON.stringify(dto));



export default {
    state: readonly(state),
    setLang,
    setColorTheme, setFontTheme,
    //initPrivateSession,
    setUsername,
    setParking,
    _requireSession: requireSession,
    sanitizeCarPlate, sanitizeDigits, sanitizeAlphanumericUpper,
    sanitizeId,cloneDTO,
    setShuttleTimer, setShuttleCalls, removeShuttleCall
};
